import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import AppRouter from './router/AppRouter';
import Portfolio from './App'

//import { composeWithDevTools } from 'redux-devtools-extension'

// React:

ReactDOM.render(<AppRouter />, document.getElementById('root'));

